"use client";

import React, { useEffect } from "react";
import { Card } from "../components/ui/card";
import purchase from "../assets/images/purchase.png";
import alert from "../assets/images/alert.png";
import { useNavigate } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Lock } from "lucide-react";
import { useAuth0 } from "@auth0/auth0-react";
export default function Unauthorized() {
  const navigate = useNavigate();
  const { logout } = useAuth0();
  const backHome = () => {
    localStorage.clear();
    logout({ logoutParams: { returnTo: window.location.origin } });
  };

  return (
    <div className="flex items-center justify-center mt-52">
      <div className="w-full max-w-5xl p-12 flex flex-col items-center text-center">
        <img
          src={alert}
          alt="Purchase Success"
          width={150}
          height={150}
          className="mb-6"
        />
        <h2 className="text-2xl font-bold text-purple-700 mb-4">
          Unauthorized
        </h2>
        <p className="mb-5 mt-5">Seems u are not supposed to be here</p>
        <Button
          onClick={backHome}
          className="w-1/2 py-3 bg-gradient-to-tr from-purple-500 to-rose-500 text-white rounded-full font-bold h-16"
        >
          Back Home
        </Button>

        <div className="flex items-center justify-center gap-1 text-sm text-gray-500 mt-6">
          <Lock size={12} />
          <p>Secured by 80Eight</p>
        </div>
      </div>
    </div>
  );
}
